// extracted by mini-css-extract-plugin
export default {"root":"print_root__rUIpv","page":"print_page__KqDdU","box":"print_box__tb1-7","flex":"print_flex__giG8q","textRight":"print_textRight__8dsuh","summery":"print_summery__RTqZf"};